import createApiClient from './apiClient';
import { cachedRequest, invalidateCache } from '../utils/apiDataCache';

function userServiceBase() {
  return (process.env.REACT_APP_ATHENIAN_USER_SERVICE_URL || '').replace(/\/api\/users\/?$/, '');
}

const schoolApi = createApiClient(`${userServiceBase()}/api/schools`);
const CACHE_PREFIX = 'school:';

function listKey(params) {
  return `${CACHE_PREFIX}list:${JSON.stringify(params || {})}`;
}

export const getSchools = (params) =>
  cachedRequest(listKey(params), () => schoolApi.get('/', { params }));

export const getSchool = (schoolId) =>
  cachedRequest(`${CACHE_PREFIX}${schoolId}`, () => schoolApi.get(`/${schoolId}`));

export const createSchool = async (data) => {
  const res = await schoolApi.post('/', data);
  invalidateCache(CACHE_PREFIX);
  return res;
};

export const updateSchool = async (schoolId, data) => {
  const res = await schoolApi.put(`/${schoolId}`, data);
  invalidateCache(CACHE_PREFIX);
  return res;
};

export const deleteSchool = async (schoolId) => {
  const res = await schoolApi.delete(`/${schoolId}`);
  invalidateCache(CACHE_PREFIX);
  return res;
};
